(() => {
  const controllers = new Map();
  const initScope = (scope) => {
    const dock = scope.querySelector('[data-ama-trial-dock]');
    const purchase = scope.querySelector('.bundle-section:not([data-bundle-disabled="true"]), [data-ama-safe-qty]');
    if (!dock || !purchase || controllers.has(scope)) return;
    const choice = dock.querySelector('[data-ama-trial-choice]');
    if (!choice) return;
    const main = scope.closest('main') || scope;
    const footer = document.querySelector('footer');
    const spacer = document.createElement('div');
    spacer.className = 'ama-trial-dock-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    main.appendChild(spacer);
    const mq = matchMedia('(max-width:749px)');
    let frame = 0;
    let dockHeight = 0;
    const sync = () => {
      const card = purchase.querySelector('.bundle-card.selected');
      const label = card?.querySelector('.bundle-qty')?.textContent.trim();
      const price = card?.querySelector('.ttc-price')?.textContent.trim();
      const safePrice = purchase.querySelector('.ama-safe-qty-2026__price')?.textContent.trim();
      const quantity = purchase.querySelector('[data-ama-qty-input]')?.value;
      choice.textContent = [label || (quantity ? '× ' + quantity : ''), price || (quantity ? '' : safePrice)].filter(Boolean).join(' · ');
    };
    const panelIsOpen = () => Array.from(document.querySelectorAll('cart-drawer.active, cart-notification.active, product-modal[open], dialog[open], header details[open]')).some((panel) => {
      const rect = panel.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && getComputedStyle(panel).visibility !== 'hidden';
    });
    const update = () => {
      frame = 0;
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const footerIsNear = footer && footer.getBoundingClientRect().top <= viewportHeight + 8;
      dock.hidden = !mq.matches || purchase.getBoundingClientRect().bottom > 100 || footerIsNear || panelIsOpen();
      if (!dock.hidden) dockHeight = Math.ceil(dock.getBoundingClientRect().height);
      spacer.style.height = mq.matches && dockHeight ? `${dockHeight}px` : '0px';
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const onChoice = () => {
      sync();
      schedule();
    };
    const onClick = () => requestAnimationFrame(onChoice);
    const choiceObserver = new MutationObserver(onChoice);
    choiceObserver.observe(purchase, {subtree:true, attributes:true, attributeFilter:['class'], childList:true});
    const panelObserver = new MutationObserver(schedule);
    document.querySelectorAll('cart-drawer, cart-notification, product-modal, header, dialog').forEach((panel) => panelObserver.observe(panel, {subtree:true, attributes:true, attributeFilter:['open','class','hidden']}));
    const intersectionObserver = new IntersectionObserver(schedule, {threshold:0});
    intersectionObserver.observe(purchase);
    if (footer) intersectionObserver.observe(footer);
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    resizeObserver?.observe(dock);
    purchase.addEventListener('input', onChoice);
    purchase.addEventListener('click', onClick);
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.visualViewport?.addEventListener('resize', schedule);
    mq.addEventListener('change', schedule);
    controllers.set(scope, () => {
      choiceObserver.disconnect();
      panelObserver.disconnect();
      intersectionObserver.disconnect();
      resizeObserver?.disconnect();
      purchase.removeEventListener('input', onChoice);
      purchase.removeEventListener('click', onClick);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.visualViewport?.removeEventListener('resize', schedule);
      mq.removeEventListener('change', schedule);
      if (frame) cancelAnimationFrame(frame);
      spacer.remove();
    });
    sync();
    update();
  };
  const init = () => document.querySelectorAll('.ama-pdp-trial').forEach(initScope);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((cleanup, scope) => {
      if (event.target === scope || event.target.contains(scope)) {
        cleanup();
        controllers.delete(scope);
      }
    });
  });
})();
